module.exports = __webpack_public_path__ + "static/img/solaris-logo-en.078d7f11.svg";